// removed by extract-text-webpack-plugin
module.exports = {"is-focused":"_1drZmqBXEwVb8DlO7cBelf","Select--rtl":"_2P3TeAzcmnBQwoXWkBK2NW","Select-animation-spin":"_3PSfQro4mO9N8QKeUTrf7Y","Select-animation-fadeIn":"_1CMA2ETFqbFwCe92zVEbQS"};


//////////////////
// WEBPACK FOOTER
// ./src/theme/global.scss
// module id = 1284
// module chunks = 47